import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var AlignBottom02 = function AlignBottom02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 18V6c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C8.3978 3 7.9319 3 7 3s-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C4 4.6022 4 5.0681 4 6v12c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C5.6022 21 6.0681 21 7 21s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C10 19.3978 10 18.9319 10 18m10 0v-8c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C18.3978 7 17.9319 7 17 7s-1.3978 0-1.7654.1522c-.49.203-.8794.5924-1.0824 1.0824C14 8.6022 14 9.0681 14 10v8c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C15.6022 21 16.0681 21 17 21s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C20 19.3978 20 18.9319 20 18"
    })
  }));
};
export default AlignBottom02;